var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAreaChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 3.3335C3.79357 3.3335 4.16667 3.7066 4.16667 4.16683V9.655L6.07741 7.74424C6.33104 7.4906 6.71852 7.42773 7.03934 7.58814L9.71467 8.92583L12.6399 4.53791C12.8731 4.18823 13.3301 4.06685 13.706 4.2548L17.0393 5.92147C17.3217 6.06263 17.5 6.35119 17.5 6.66683V15.8335C17.5 16.2937 17.1269 16.6668 16.6667 16.6668H3.33333C2.8731 16.6668 2.5 16.2937 2.5 15.8335V11.667C2.5 11.6669 2.5 11.6671 2.5 11.667V4.16683C2.5 3.7066 2.8731 3.3335 3.33333 3.3335ZM4.16667 12.012V15.0002H15.8333V7.18185L13.6187 6.07451L10.6934 10.4624C10.4602 10.8121 10.0033 10.9335 9.62733 10.7455L6.83121 9.3475L4.16667 12.012Z",
    fill: "#FFFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaChart);
export default __webpack_public_path__ + "static/media/AreaChart.d2f226f1c78857db4ec321b298401da2.svg";
export { ForwardRef as ReactComponent };